var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAutopay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 29,
    viewBox: "0 0 116 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.642 8.69442C14.642 4.57715 11.479 1.2398 7.321 1.2398C3.164 1.2398 0 4.57715 0 8.69442V23.6037H1.83C1.83 20.5157 4.289 18.0129 7.321 18.0129C10.353 18.0129 12.812 20.5164 12.812 23.6037H14.642V8.69442Z",
    fill: "#199BFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.835 0L20.134 23.6045H24.309L25.217 18.4218H30.404L31.312 23.6045H35.608L30.906 0H24.835ZM25.8 15.1859L27.81 3.79617L29.82 15.1859H25.8Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.903 18.19C44.903 19.8736 43.963 20.6992 42.698 20.6992C41.434 20.6992 40.883 19.9732 40.883 18.421V6.33822H36.862V18.949C36.862 22.3161 38.548 23.9007 41.012 23.9007C43.022 23.9007 44.255 22.8771 44.903 21.4575V23.6031H48.924V6.33822H44.903V18.19Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.31 2.87214H55.33V6.33895H58.086V9.34314H55.33V18.7841C55.33 19.9727 55.816 20.5007 56.854 20.5007C57.373 20.5007 57.859 20.4347 58.086 20.3357V23.4718C57.762 23.6038 56.984 23.7358 56.076 23.7358C52.737 23.7358 51.31 22.2172 51.31 19.1141V2.87214Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.699 6.04164C62.003 6.04164 59.344 8.25322 59.344 12.512V17.4968C59.344 21.6896 62.003 23.9011 65.666 23.9011C69.33 23.9011 72.118 21.6896 72.118 17.4308V12.446C72.118 8.22022 69.427 6.04164 65.699 6.04164ZM68.066 17.5964C68.066 19.709 67.288 20.7656 65.699 20.7656C64.109 20.7656 63.364 19.709 63.364 17.5964V12.3146C63.364 10.1691 64.175 9.14546 65.699 9.14546C67.222 9.14546 68.066 10.1691 68.066 12.3476V17.5964Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.148 8.45169C78.829 7.1311 80.158 6.04149 82.104 6.04149C84.989 6.04149 86.902 8.02144 86.902 12.1482V17.7276C86.902 21.8874 84.892 23.901 81.941 23.901C80.061 23.901 78.731 22.944 78.148 21.6234V29H74.127V6.33912H78.148V8.45169ZM80.579 20.7984C82.071 20.7984 82.849 19.8408 82.849 17.7613V12.1495C82.849 10.0039 82.006 9.17831 80.579 9.17831C79.023 9.17831 78.115 10.2679 78.115 12.4135V17.5303C78.115 19.6758 78.926 20.7984 80.579 20.7984Z",
    fill: "#282828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.411 8.31985C96.795 6.93325 95.66 6.04164 93.779 6.04164C90.926 6.04164 88.786 8.05522 88.786 12.248V17.7284C88.786 21.9212 90.796 23.9018 93.585 23.9018C95.53 23.9018 96.762 22.8122 97.411 21.4256V23.6042H101.431V6.33863H97.411V8.31985ZM97.443 17.4974C97.443 19.643 96.535 20.7656 94.979 20.7656C93.617 20.7656 92.839 19.907 92.839 17.7944V12.182C92.839 10.0364 93.617 9.11183 95.077 9.11183C96.633 9.11183 97.444 10.2344 97.444 12.446V17.4968L97.443 17.4974Z",
    fill: "#282828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 16.8364L112.061 6.33822H116L109.487 28.9997H105.453L107.457 22.2178L102.561 6.33822H106.841L109.5 16.8364Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAutopay);
export default __webpack_public_path__ + "static/media/logo-autopay.d82f97131e2008166fdc048bfb151fdb.svg";
export { ForwardRef as ReactComponent };